import React from "react";
import { PageHeader } from "../components/PageHeader";

export default function SirketProfili() {
  const milestones = [
    { year: "2003", t: "Kuruluş", d: "Yalova merkezde döviz bürosu olarak faaliyetimize başladık." },
    { year: "2008", t: "Genişleme", d: "Hizmet yelpazemize altın alım-satımını ekledik." },
    { year: "2015", t: "Dijitalleşme", d: "Online kur takip altyapımızı kurduk." },
    { year: "2020", t: "Kurumsal Yapı", d: "Kurumsal müşteri portföyümüzü genişlettik." },
    { year: "2026", t: "Yeni Nesil", d: "Canlı piyasa verileriyle entegre yeni web platformumuzla yeni dönem başlattık." },
  ];

  return (
    <>
      <PageHeader
        eyebrow="Kurumsal · B Grubu Yetkili Müessese"
        title="Şirket Profili"
        description="Akaydın Döviz Ve Altın Ticareti Sınırlı Yetkili Müessese A.Ş.'nin kuruluşundan bugüne uzanan kurumsal yolculuğu."
        image="https://images.unsplash.com/photo-1714601344981-75e003bc5d18"
      />
      <section className="py-20 md:py-28">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="p-8 md:p-10 rounded-2xl bg-slate-950 text-white mb-12 relative overflow-hidden">
            <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-brand-gold/15 blur-3xl" />
            <div className="relative">
              <div className="text-[11px] uppercase tracking-[0.25em] text-brand-gold font-bold mb-3">
                Resmi Ünvan
              </div>
              <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight leading-tight mb-2">
                Akaydın Döviz Ve Altın Ticareti Sınırlı Yetkili Müessese A.Ş.
              </h2>
              <p className="text-slate-300 text-sm">B Grubu Yetkili Müessese</p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {[
              {
                t: "Faaliyet Alanı",
                d: "Yetkili döviz bürosu olarak USD, EUR, GBP, CHF, JPY ve diğer 20+ döviz çeşidi ile gram altın, çeyrek, yarım, tam ve cumhuriyet altını alım-satım hizmetleri.",
              },
              {
                t: "Hedef Kitle",
                d: "Bireysel müşteriler, KOBİ'ler, ihracatçılar, ithalatçılar, turist ve kurumsal yatırımcılar.",
              },
              {
                t: "Bölge",
                d: "Yalova merkez başta olmak üzere, Marmara Bölgesi'nin önemli ticaret noktalarına hizmet veriyoruz.",
              },
              {
                t: "Değerlerimiz",
                d: "Şeffaflık, güvenilirlik, hız, müşteri memnuniyeti ve etik iş yapış prensibi.",
              },
            ].map((b, i) => (
              <div key={i} className="p-7 rounded-2xl border border-slate-200 bg-white hover:border-brand-gold/40 transition-colors">
                <div className="text-[11px] uppercase tracking-[0.25em] text-brand-gold font-bold mb-3">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="font-display text-xl font-bold text-slate-950 mb-2">{b.t}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{b.d}</p>
              </div>
            ))}
          </div>

          <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-950 tracking-tight mb-10">
            Tarihçemiz
          </h2>

          <div className="relative">
            <div className="absolute left-4 md:left-6 top-2 bottom-2 w-px bg-slate-200" />
            <div className="space-y-8">
              {milestones.map((m, i) => (
                <div key={i} className="relative pl-14 md:pl-20">
                  <div className="absolute left-0 md:left-1 top-1 w-9 h-9 md:w-12 md:h-12 rounded-full bg-slate-950 text-brand-gold font-display font-bold text-xs md:text-sm flex items-center justify-center">
                    {m.year.slice(2)}
                  </div>
                  <div className="text-[11px] uppercase tracking-[0.25em] text-brand-gold font-bold mb-1">
                    {m.year}
                  </div>
                  <h3 className="font-display text-xl font-bold text-slate-950 mb-1">{m.t}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{m.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
